import { Injectable } from '@angular/core';

import { BusinessStatusCodeEnum } from '../../shared/enums/business-status-code.enum';
import { HttpMethodEnum } from '../../shared/enums/http-method.enum';

import { Logger } from './logger.abstract';

/* eslint-disable @typescript-eslint/no-unused-vars */
@Injectable()
export class LoggerService implements Logger {
  public debug(
    errorMessage: string,
    cause?: string,
    businessErrorId?: BusinessStatusCodeEnum,
    calledUrl?: string,
    httpRequestMethod?: HttpMethodEnum,
    stackTrace?: string,
  ): any {
    // do nothing
  }

  public info(
    errorMessage: string,
    cause?: string,
    businessErrorId?: BusinessStatusCodeEnum,
    calledUrl?: string,
    httpRequestMethod?: HttpMethodEnum,
    stackTrace?: string,
  ): any {
    // do nothing
  }

  public warn(
    errorMessage: string,
    cause?: string,
    businessErrorId?: BusinessStatusCodeEnum,
    calledUrl?: string,
    httpRequestMethod?: HttpMethodEnum,
    stackTrace?: string,
  ): any {
    // do nothing
  }

  public error(
    errorMessage: string,
    cause?: string,
    businessErrorId?: BusinessStatusCodeEnum,
    calledUrl?: string,
    httpRequestMethod?: HttpMethodEnum,
    stackTrace?: string,
  ): any {
    // do nothing
  }
  /* eslint-enable @typescript-eslint/no-unused-vars */
}
